<template>
  <div class="signup-page">
    <b-container>
      <b-row class="justify-content-center align-items-center" style="min-height: 80vh;">
        <b-col md="6" lg="5">
          <b-card class="shadow-sm border-0">
            <h2 class="text-center mb-4 font-weight-bold">{{ $t('auth.signup_title') }}</h2>
            
            <b-alert v-if="error" show variant="danger">{{ error }}</b-alert>

            <b-form @submit.prevent="signup">
              <b-form-group :label="$t('auth.email')" label-for="email">
                <b-form-input
                  id="email"
                  v-model="email"
                  type="email"
                  required
                  :placeholder="$t('auth.email_placeholder')"
                ></b-form-input>
              </b-form-group>

              <b-form-group :label="$t('auth.password')" label-for="password">
                <b-form-input
                  id="password"
                  v-model="password"
                  type="password"
                  required
                  :placeholder="$t('auth.password_placeholder')"
                ></b-form-input>
              </b-form-group>

              <b-button type="submit" variant="success" block class="mt-4" :disabled="loading">
                <b-spinner v-if="loading" small></b-spinner>
                <span v-else>{{ $t('auth.signup_button') }}</span>
              </b-button>
            </b-form>

            <div class="text-center mt-3">
              <p class="text-muted">
                {{ $t('auth.has_account') }} 
                <router-link to="/login" class="text-success font-weight-bold">{{ $t('auth.login_link') }}</router-link>
              </p>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import { db } from '../main'

export default {
  name: 'Signup',
  data() {
    return {
      email: '',
      password: '',
      error: '',
      loading: false
    }
  },
  methods: {
    async signup() {
      this.loading = true;
      this.error = '';
      try {
        const userCredential = await firebase.auth().createUserWithEmailAndPassword(this.email, this.password);
        const user = userCredential.user;

          // Create user in Firestore
          await db.collection('Users').doc(user.uid).set({
            email: this.email,
            createdAt: new Date(),
            balance: 0.00,
            role: 'user' // Default role
          });

          // Send Verification Email
          await user.sendEmailVerification();
          alert(`Account created! A verification email has been sent to ${this.email}. Please verify before logging in.`);

          this.$router.push('/dashboard');
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.signup-page {
  background-color: #f8f9fa;
  min-height: 100vh;
}
</style>
